import { useFeatureFlag } from "@evidenceb/athena-common/modules/FeatureFlags";
import { useTutos } from "../../Tuto/useTutos";
import { useWorkshops } from "../../Workshop/useWorkshops";

export const usePlaylistableCollections = () => {
  const workshopsFlag = useFeatureFlag("workshopsInPlaylist");
  const { data: workshops, queries: workshopQueries } = useWorkshops({
    enabled: workshopsFlag,
  });
  const tutosFlag = useFeatureFlag("tutosInPlaylist");
  const { data: tutos, queries: tutoQueries } = useTutos({
    enabled: tutosFlag,
  });
  return {
    data: [...(workshopsFlag ? workshops : []), ...(tutosFlag ? tutos : [])],
    queries: [
      ...(workshopsFlag ? workshopQueries : []),
      ...(tutosFlag ? tutoQueries : []),
    ],
  };
};
